module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHZJREFUeNpiYBgFo2DEAUZ0gbCwsP1AyoGAvgOrVq1yhHGYsCgIBOIHeAx4AFXDgNMQoA0foIo+YDEALAdVAwfM2Ky6evXqC21t7ZdAZgCaVCbQgB3o6plxuRlo0AWgQQJApgVUaALQgE6yQh4U0NDAxgkAAgwA4OAivVwakTkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/common-images/reports/down.png
// module id = ../../../../syncfusion-javascript/Content/ej/web/common-images/reports/down.png
// module chunks = 2